var path = 'msi/addresses/shipping-dropdown/shipping-dropdown.html';
var html = "<og-formfield>\n  <select ng-options=\"address.publicId as address.address for address in $ctrl.addresses\" ng-model=\"$ctrl.model\" id=\"og-stored-addresses\">\n  </select>\n</og-formfield>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;